import React, { useState } from "react";
import { useEffect } from "react";
import { Outlet } from "react-router";
import Header from "../../components/Header/Header";
import { CONNECT_PAGE } from "../../utils/constants";
import { logEvents, trackEvent } from "../../utils/functions";

const ConnectPage = () => {
  const [selectedCon, setSelectedCon] = useState("");

  useEffect(() => {
    trackEvent(CONNECT_PAGE);
    logEvents(CONNECT_PAGE);
  }, []);
  return (
    <div>
      <Header type="connect" />
      <Outlet
        context={{ selectedCon: selectedCon, setSelectedCon: setSelectedCon }}
      />
    </div>
  );
};

export default ConnectPage;
